// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1492":"css/app.6811","2362":"css/admin-app.6811"}[chunkId] + ".css";
};